module.exports = __webpack_public_path__ + "static/img/set_warehouse_icon.38b2bd85.png";